import { useMemo, useState, type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import { TabMenu } from '@/_components/tab-menu/tab-menu';
import styles from './fare-tab.module.scss';
import type { FareType, TypeFranchiseForm } from '../../types';
import { FareTabItems } from '../../types';
import { FARE_TAB_OPTIONS } from '../../constants';

interface FareTabProps {
  tabMenus: Record<FareTabItems, ReactElement>;
  fareType: FareType;
  startsOnTheTab: FareTabItems;
}

export const FareTab = ({
  tabMenus,
  fareType,
  startsOnTheTab,
}: FareTabProps) => {
  const {
    formState: { errors },
  } = useFormContext<TypeFranchiseForm>();

  const FILTERED_TABS =
    fareType === 'Place'
      ? FARE_TAB_OPTIONS.filter(tab => tab.key !== FareTabItems.MAP)
      : FARE_TAB_OPTIONS;
  const [activeTab, setActiveTab] = useState<FareTabItems>(startsOnTheTab);

  const hasErrorsInNeighborhoodTab = Object.keys(errors).some(errorKey =>
    errorKey.startsWith('bairros'),
  );

  const hasErrorsInMapTab = Object.keys(errors).some(errorKey =>
    ['localizacao', 'codigoIbge'].includes(errorKey),
  );

  const TABS_WITH_NOTIFICATION: FareTabItems[] = useMemo(() => {
    const tabs: FareTabItems[] = [];
    if (hasErrorsInMapTab) {
      tabs.push(FareTabItems.MAP);
    }
    if (hasErrorsInNeighborhoodTab) {
      tabs.push(FareTabItems.NEIGHBORHOOD);
    }
    return tabs;
  }, [hasErrorsInMapTab, hasErrorsInNeighborhoodTab]);

  return (
    <div className={styles.tabNavigator}>
      <TabMenu
        activatedTab={activeTab}
        tabs={FILTERED_TABS}
        onChange={setActiveTab}
        id="fare-tab"
        tabsWithNotification={TABS_WITH_NOTIFICATION}
      />

      <main>{tabMenus[activeTab]}</main>
    </div>
  );
};
